import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Label, Input, Table, Button } from "reactstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import Header from "../../../layout/Header/Header";
import { FiltroTipoHabilitacion } from "../Habilitacion/TiposHabilitacion";

/**
 * Cuanta tela y habilitacion hay en cada almacen, incluidos los de los
 * maquileros. Es la vista que contesta "que trae el taller en su poder".
 */
function ExistenciasMateriales() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS_MATERIALES = process.env.REACT_APP_URL_INVENTARIOS_MATERIALES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;

  const [saldos, setSaldos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [filtroAlmacen, setFiltroAlmacen] = useState("");
  // Desde el menu se llega con ?tipo=Telas|Habilitacion (reemplaza a los
  // inventarios viejos de tela por rollo y de habilitacion).
  const [filtroTipo, setFiltroTipo] = useState(new URLSearchParams(window.location.search).get("tipo") || "");
  const [busqueda, setBusqueda] = useState("");
  // Tipo de habilitacion (BOTÓN, CIERRE...): solo aplica a la habilitacion.
  const [filtroTipoHab, setFiltroTipoHab] = useState("");

  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  useEffect(() => {
    axios
      .get(URL_AREAS, { headers })
      .then((res) => setAreas(res.data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let vigente = true; // descarta la respuesta de un filtro anterior
    let url = `${URL_INVENTARIOS_MATERIALES}?conExistencia=Si`;
    if (filtroAlmacen) url += `&areas=${filtroAlmacen}`;
    if (filtroTipo) url += `&tipoMaterial=${filtroTipo}`;
    axios
      .get(url, { headers })
      .then((res) => vigente && setSaldos(res.data))
      .catch((err) => console.log(err));
    return () => { vigente = false; };
  }, [filtroAlmacen, filtroTipo]);

  const tipoHab = (a) => (a.tipoMaterial === "Telas" ? "" : (a.material && a.material.tipo) || "");
  const visibles = saldos.filter((a) => {
    if (filtroTipoHab && (a.tipoMaterial === "Telas" || tipoHab(a) !== filtroTipoHab)) return false;
    if (!busqueda) return true;
    const texto = `${a.material ? a.material.nombre : ""} ${tipoHab(a)} ${a.colores ? a.colores.name : ""} ${
      a.areas ? a.areas.name : ""
    }`.toLowerCase();
    return texto.includes(busqueda.toLowerCase());
  });

  const n = (x) => new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(x || 0);
  const COLUMNAS = ["Almacen", "Tipo", "Tipo de habilitación", "Material", "Color", "Unidad", "Existencia", "Apartado", "Disponible"];
  const datos = () =>
    visibles.map((a) => [
      a.areas ? a.areas.name : "", a.tipoMaterial === "Telas" ? "Tela" : "Habilitacion", tipoHab(a),
      a.material ? a.material.nombre : "", a.colores ? a.colores.name : "-", a.material ? a.material.unidad || "" : "",
      n(a.cantidad), n(a.apartado), n(a.disponible ?? a.cantidad),
    ]);
  function PDF() {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img, "png", 230, 8, 45, 22);
    doc.text("Existencias de Material", 20, 20);
    doc.autoTable({ head: [COLUMNAS], body: datos(), startY: 34, styles: { fontSize: 8 } });
    doc.save("ExistenciasMaterial.pdf");
  }
  function excel() {
    new ExportJsonExcel({
      fileName: "ExistenciasMaterial",
      datas: [{
        sheetData: datos().map((r) => Object.fromEntries(COLUMNAS.map((c, i) => [c, r[i]]))),
        sheetName: "Existencias", sheetFilter: COLUMNAS, sheetHeader: COLUMNAS,
      }],
    }).saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-warehouse" style={{ marginRight: 8, color: "#0ea5e9" }} />
                Existencias de Material
              </h3>
              <p className="page-subtitle">Tela y habilitacion por cantidad y almacen, incluidos los maquileros</p>
            </div>
            <div>
              <Button color="danger" size="sm" onClick={PDF} style={{ marginRight: 6 }}>PDF</Button>
              <Button color="success" size="sm" onClick={excel}>Excel</Button>
            </div>
          </div>

          <Row style={{ marginBottom: 16 }}>
            <Col md={3}>
              <Label>Almacen</Label>
              <Input type="select" value={filtroAlmacen} onChange={(e) => setFiltroAlmacen(e.target.value)}>
                <option value="">Todos</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option value={a._id} key={a._id}>
                      {a.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Tipo</Label>
              <Input type="select" value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)}>
                <option value="">Todos</option>
                <option value="Telas">Tela</option>
                <option value="Habilitacion">Habilitacion</option>
              </Input>
            </Col>
            {filtroTipo !== "Telas" ? (
              <Col md={3}>
                <Label>Tipo de habilitación</Label>
                <FiltroTipoHabilitacion value={filtroTipoHab} onChange={setFiltroTipoHab} />
              </Col>
            ) : null}
            <Col md={4}>
              <Label>Buscar</Label>
              <Input
                type="text"
                placeholder="Material, color o almacen"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </Col>
          </Row>

          <Table size="sm" striped borderless responsive>
            <thead>
              <tr>
                <th>Almacen</th>
                <th>Tipo</th>
                <th>Tipo de habilitación</th>
                <th>Material</th>
                <th>Color</th>
                <th>Unidad</th>
                <th style={{ textAlign: "right" }}>Existencia</th>
                <th style={{ textAlign: "right" }}>Apartado</th>
                <th style={{ textAlign: "right" }}>Disponible</th>
              </tr>
            </thead>
            <tbody>
              {visibles
                .sort((a, b) => {
                  const alm = (a.areas ? a.areas.name : "").localeCompare(b.areas ? b.areas.name : "");
                  if (alm !== 0) return alm;
                  return (a.material ? a.material.nombre : "").localeCompare(
                    b.material ? b.material.nombre : ""
                  );
                })
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.areas ? a.areas.name : ""}</td>
                    <td>{a.tipoMaterial === "Telas" ? "Tela" : "Habilitacion"}</td>
                    <td>{tipoHab(a)}</td>
                    <td>{a.material ? a.material.nombre : ""}</td>
                    <td>{a.colores ? a.colores.name : "-"}</td>
                    <td>{a.material ? a.material.unidad : ""}</td>
                    <td style={{ textAlign: "right" }}>{n(a.cantidad)}</td>
                    <td style={{ textAlign: "right", color: a.apartado > 0 ? "#8b5cf6" : undefined }}>{n(a.apartado)}</td>
                    <td style={{ textAlign: "right", fontWeight: 600 }}>{n(a.disponible ?? a.cantidad)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
          {visibles.length === 0 ? (
            <p style={{ textAlign: "center", color: "#94a3b8" }}>Sin existencias con ese filtro</p>
          ) : undefined}
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ExistenciasMateriales;
